import { LineData, UTCTimestamp } from 'lightweight-charts';
import { DataService } from '../Services/Data.service';
//import { DumyDataService } from '../Services/dumy-data.service';
import { Subject, of } from 'rxjs';
import { LineWave, SerieColor } from './LineSerie';
import { ISendTradeData, getTradeTime } from './HubModels';
import { DrawingService } from '../Services/DrawingService';
import { getSupportedInputTypes } from '@angular/cdk/platform';
import { CandlestickItem } from './lcharts/src/renderers/candlesticks-renderer';
import { HistogramData, Time } from './lcharts/src/api/data-consumer';
import { LoggerService } from '../Services/Logger/Logger';

export class WaveDrawer {

  private _waves: Wave[] = [];
  private _intermediateWaves: Wave[] = [];
  private _base: number = -1;
  private _prevbase: number = -1;
  //public pernamentLineWidth: 3;

  public waveDrawSignaler: Subject<DrawingAction> = new Subject<DrawingAction>();

  constructor(private dataservice: DataService, private drawingService: DrawingService, private isBackground?: boolean) {



  }

  private lastPernamentDirection: WaveDirection;
  private lastPernamentPrice: Number;

  public lastWave: Wave = null;
  public updateLastWaves(lastWaves): boolean {

    try {

      let waves: Wave[] = lastWaves.map(m => {

        if(!m)return;

        return {
          type: (m.data[1] != null && m.data[1].price != m.data[0].price) ? m.type : WaveType.NOWAVE,
          direction: m.direction,
          data: [
            { time: getTradeTime(m.data[0].time), value: m.data[0].price },
            (m.data[1] != null) ? { time: getTradeTime(m.data[1].time), value: m.data[1].price } : null
          ]
        }

      });

      // if(!waves[0] || !waves[1] || !waves[2]){
      //   window.location.href="/";
      // };

      let compare = waves.filter(v => {
        return v.type == WaveType.PERNAMENT
      })

      if (compare.length > 0) {
        let lastToCompare = compare[compare.length - 1];
        let lastWave = this.getLastPernamentWave();

        if (
          lastToCompare.data[1].time == lastWave.data[1].time &&
          lastToCompare.data[1].value == lastWave.data[1].value
        ) {
          return false
        }
        else {
          //console.log("MAIN IS REQUIRED")
        }


      }



      this.lastWave = waves[waves.length - 1];

      let findfirstupdate = this._waves.find(v => {
        return v.data[0].time == waves[0].data[0].time
      })

      let index = this._waves.indexOf(findfirstupdate);
      let getSliced = this._waves.slice(index);

      this.drawingService.activeRetracements.lastTimes = [];
      getSliced.forEach(v => {
        if (v.serie && v.serie._lineSeries) {
          if (v.serie && v.serie._lineSeries) {


            this.drawingService.activeRetracements.sliceRetracement(v.serie._lineSeries.getSerieIndex(), v.data[0].time);

            this.drawingService.chart.chart.removeSeries(v.serie._lineSeries);



          }

        }
      });


      this._waves.splice(index);


      if (waves[waves.length - 1].type != WaveType.PERNAMENT) {



        if (this._intermediateWaves.length > 0) {



          //  this.intermediatesToOneSerie();
          let canPush: boolean = true;
          if (waves[waves.length - 1].data[1]) {


            if (this.currentIntermediatesDirection == WaveDirection.UP && this.currentLastValue < waves[waves.length - 1].data[1].value) {

              this._intermediateWaves[this._intermediateWaves.length - 1] = waves[waves.length - 1];
              canPush = false;

            }

            if (this.currentIntermediatesDirection == WaveDirection.DOWN && this.currentLastValue > waves[waves.length - 1].data[1].value) {

              this._intermediateWaves[this._intermediateWaves.length - 1] = waves[waves.length - 1];
              canPush = false;

            }

            let diff = Math.abs((this.currentLastValue - waves[waves.length - 1].data[1].value))


            if (diff < this.drawingService.intermediateLineHeight || this.currentLastValue == waves[waves.length - 1].data[1].value) {
              canPush = false;
            }

          }

          if (canPush) {
            this._intermediateWaves.push(waves[waves.length - 1]);
          }


        }

        if (this._intermediateWaves.length == 0 && waves[waves.length - 1].type == WaveType.INTERMEDIATE) {
          this._intermediateWaves.push(waves[waves.length - 1]);
        }

      }

      this._waves.push(...waves);

      let lastPernament: Wave;
      if (this._waves.length > 0) {
        let f = 1;

        if (this._waves.find(v => { return v.type == WaveType.PERNAMENT })) {
          do {
            lastPernament = this._waves[this._waves.length - f];
            f++;

          }
          while (lastPernament == undefined || lastPernament.type != WaveType.PERNAMENT);
        }
        else {
          lastPernament = this._waves[this._waves.length - 1];
        }
      }

      if (this.lastPernamentDirection != lastPernament.direction || (this.lastPernamentDirection == lastPernament.direction && this.lastPernamentPrice != lastPernament.data[1].value)) {
        // //console.log("NEW INTERMEDIATES");

        this._intermediateWaves = [];
        this.currentIntermediatesDirection = WaveDirection.NODIRECTION
      }

      this.lastPernamentDirection = lastPernament.direction;
      this.lastPernamentPrice = lastPernament.data[1].value;

      var activeTimes =this.drawingService.activeRetracements.lastTimes;
      waves.forEach(v => {

        if (v.type != WaveType.INTERMEDIATE) {
          let serie: LineWave = new LineWave(this.drawingService.chart.chart, v.data, this.drawingService.pernamentLineWidth, v.type, v.direction, false, this.drawingService);
          v.serie = serie;
         // //console.log(serie._lineSeries.getSerieIndex());
         if(serie._lineSeries)
         {
           if(activeTimes.indexOf(v.data[0].time)>-1)
           {
             this.drawingService.activeRetracements.activeNewRetracementIndicator(serie._lineSeries.getSerieIndex(), v.data[0].time, true);
           }

         }

        }

      })

      this.waveDrawSignaler.next();

      return true

    }
    catch (e) {
      //console.log(e);
      return false;
    }


  }


  public getLastWaves(numberOfWaves: number) {

    const fromIndex: number = this._waves.length > numberOfWaves ? this._waves.length - numberOfWaves : 0
    return this._waves.slice(fromIndex);
  }


  public getLastPernamentWave(index?: number): Wave {

    try{
    if (!index) {
      index = this._waves.length - 1;
    }
    else {
      index--;
    }

    if (this._waves[index].type == WaveType.PERNAMENT) {
      return this._waves[index];
    }
    else {
      return this.getLastPernamentWave(index);
    }
  }
  catch(e)
  {
    LoggerService.logError(e);
  }
    //const fromIndex: number = this._waves.length > numberOfWaves ? this._waves.length - numberOfWaves : 0
    // return this._waves.slice(fromIndex);
  }
  public getWaveTimeRange(numberOfWaves: number) {
    try {
      let waves = this.getLastWaves(numberOfWaves);
      let tradeData = this.drawingService.getAllTradeData();


      let rangeEnd = (waves[waves.length - 1] && waves[waves.length - 1].data[1]) ? waves[waves.length - 1].data[1].time : tradeData[tradeData.length - 1].time;
      return [waves[0].data[0].time, rangeEnd]
    }
    catch (e) {
      //console.log(e);
      return [];
    }

  }


  get CurrentWave(): Wave {
    return this._waves[this._waves.length - 1];
  }

  get PrevWave(): Wave {
    return this._waves[this._waves.length - 2];
  }

  public getAllWaves() {
    return this._waves;
  }

  public resetAll() {
    this._waves = [];
  }


  public spliceBottomWaves(num: number) {

    let getSliced = this._waves.slice(0, num);

    getSliced.forEach(v => {
      if (v.serie && v.serie._lineSeries) {
        if (v.serie && v.serie._lineSeries) {
          this.drawingService.chart.chart.removeSeries(v.serie._lineSeries)
        }

      }
    });


    this._waves.splice(0, num);
  }

  public drawInitWaves(waves: Wave[], chart) {

    this._waves = [];

    waves.forEach(v => {

      if(v==null || v==undefined){
     //   window.location.href="/";
        console.log("sitereload_type1");
      }
      else
      {
        if (v.type != WaveType.NOWAVE) {
          let serie: LineWave = new LineWave(chart, v.data, this.drawingService.pernamentLineWidth, v.type, v.direction, false, this.drawingService);
          v.serie = serie
        }
        this._waves.push(v);
      }




    })



  }


  public initBackgroundWaves(waves: Wave[]) {
    this._waves = waves;
  }

  public upgradeBackgroundWaves(lastWaves) {

    try {
      let waves: Wave[] = lastWaves.filter(v => {

        if(v==null)return false;

        return v.type == WaveType.PERNAMENT
       }).map(m => {
        if(m==null)return;
        return {
          type: m.type,
          direction: m.direction,
          data: [
            { time: getTradeTime(m.data[0].time), value: m.data[0].price },
            { time: getTradeTime(m.data[1].time), value: m.data[1].price }
          ]
        }

      });

      if(waves[waves.length - 1])
      {
        if (
          this.pernamentSerie[this.pernamentSerie.length - 1]!=undefined &&
          this.pernamentSerie[this.pernamentSerie.length - 1].time == waves[waves.length - 1].data[1].time &&
          this.pernamentSerie[this.pernamentSerie.length - 1].value == waves[waves.length - 1].data[1].value
        ) {
          return false
        }
      }
      else
      {
        return true;
      }

      let findfirstupdate = this._waves.find(v => {
        return v.data[0].time == waves[0].data[0].time
      })

      let index = this._waves.indexOf(findfirstupdate);

      this._waves.splice(index);

      this._waves.push(...waves);

      let length = this.getAllWaves().length;
      var diff = length - this.drawingService.overlayConfig.totalNumberOfWaves;

      this._waves.splice(0, diff);

      this.mergeToOneBackgroundSerie();

      return true;
    }
    catch (e) {
      LoggerService.logError(e);

    }

  }


  public mergeToOneBackgroundSerie() {
    //  console.time("MERGE");
    this.finalBase = [];
    if (this._waves.length > 0 && this._waves[0].type == WaveType.PERNAMENT) {
      this.initWaveDirection = this._waves[0].direction;


      for (let i = 0; i < this._waves.length; i++) {


        if (i == 0) {
          if (this._waves[i].type == WaveType.PERNAMENT)
            this.finalBase.push({ data: this._waves[i].data[0], pointBaseType: this.getSupportedInputTypes(i + 1, this.initWaveDirection) });
        }

        if(this._waves[i]==undefined)
        {
          return;
        }

        if (this._waves[i].type == WaveType.PERNAMENT)
          this.finalBase.push({ data: this._waves[i].data[1], pointBaseType: this.getSupportedInputTypes(i, this.initWaveDirection) });

      }
    }

    const ln = Object.assign([], this.finalBase);


    this.pernamentSerie = this.finalBase.map(v => {
      const dataL: LineData = {
        time: v.data.time,
        value: v.data.value// + 1

      };


      return dataL;
    })


  }



  public finalBase: finalBasepoint[] = [];
  public pernamentSerie: LineData[] = [];
  public zigZagSeriData: LineData[] = [];
  public histogramData: HistogramData[] = [];



  public initWaveDirection: WaveDirection = WaveDirection.NODIRECTION;

  public mergeToOneSerie() {
    //  console.time("MERGE");
    this.finalBase = [];
    if (this._waves.length > 0 && this._waves[0].type == WaveType.PERNAMENT) {
      this.initWaveDirection = this._waves[0].direction;




      for (let i = 0; i < this._waves.length; i++) {


        if (i == 0) {
          if (this._waves[i].type == WaveType.PERNAMENT)
            this.finalBase.push({ data: this._waves[i].data[0], pointBaseType: this.getSupportedInputTypes(i + 1, this.initWaveDirection) });
        }

        if (this._waves[i].type == WaveType.PERNAMENT)
          this.finalBase.push({ data: this._waves[i].data[1], pointBaseType: this.getSupportedInputTypes(i, this.initWaveDirection) });

      }
    }

    const ln = Object.assign([], this.finalBase);


    this.pernamentSerie = this.finalBase.map(v => {
      const dataL: LineData = {
        time: v.data.time,
        value: v.data.value// + 1

      };


      return dataL;
    })




    this.renderPernament();

  }

  private currentIntermediatesDirection: WaveDirection = WaveDirection.NODIRECTION;
  private currentLastValue: number = null;


  intermediatesToOneSerie() {
    let serie: LineData[] = []
    let lastPernament: Wave;
    if (this._waves.length > 0) {
      let f = 1;


      if (this._waves.find(v => { return v.type == WaveType.PERNAMENT })) {
        do {
          lastPernament = this._waves[this._waves.length - f];
          f++;

        }
        while (lastPernament == undefined || lastPernament.type != WaveType.PERNAMENT);
      } else {
        lastPernament = this._waves[this._waves.length - 1];
      }

      serie.push(lastPernament.data[1]);

      for (let i = 0; i < this._intermediateWaves.length; i++) {

        serie.push(this._intermediateWaves[i].data[1]);

      }


      if (serie[serie.length - 2] != undefined) {
        this.currentIntermediatesDirection = ((serie[serie.length - 1].value - serie[serie.length - 2].value) > 0) ? WaveDirection.UP : WaveDirection.DOWN;
      }

      this.currentLastValue = serie[serie.length - 1].value;

    }
    return serie
  }



















  public renderPernament() {
    this.zigZagSeriData = [];
    this.stopper = 0;
    if (this.finalBase.length >= 2) {
      this.generatePernament(this.pernamentSerie, this.finalBase[0].pointBaseType)
    }

  }


  public generatePernament(include: LineData[], firstType: PointBaseType) {

    if (include[2] == undefined || include[0] == undefined) {
      return;
    }

    let direction: TrendDirection = (firstType == PointBaseType.MINIMUM) ? TrendDirection.UPTREND : TrendDirection.DOWNTREND;

    let slice = 0;
    if (firstType == PointBaseType.MINIMUM && (include[2].value - include[0].value) > 0) {
      direction = TrendDirection.UPTREND;
      slice = 0;
      this.zigZagSeriData.push(include[slice]);
    }

    if (firstType == PointBaseType.MINIMUM && (include[2].value - include[0].value) < 0) {
      direction = TrendDirection.DOWNTREND;
      slice = 1
      this.zigZagSeriData.push(include[slice]);
    }

    if (firstType == PointBaseType.MAXIMUM && (include[2].value - include[0].value) < 0) {
      direction = TrendDirection.DOWNTREND;
      slice = 0;
      this.zigZagSeriData.push(include[slice]);
    }

    if (firstType == PointBaseType.MAXIMUM && (include[2].value - include[0].value) > 0) {
      direction = TrendDirection.UPTREND;
      slice = 1
      this.zigZagSeriData.push(include[slice]);
    }


    this.prepareData(direction, include.slice(slice));





  }

  public stopper: number = 0;
  prepareData(direction, data: LineData[]) {

    var start = 0;
    this.stopper++;
    do {
      try {

        var stop = 0;
        var wallDiff = 0;
        var secondWallDiff = 0;

        wallDiff = (direction * (data[start + 2].value - data[start].value) > 0) ? 1 : -1;
        secondWallDiff = (direction * (data[start + 3].value - data[start + 1].value) > 0) ? 1 : -1;
        start += 2;
      }
      catch (e) {
        wallDiff = 0;
        secondWallDiff = 0;
        start += 2;
      }

    }
    while ((wallDiff + secondWallDiff) > 0);

    let newdirection: TrendDirection = (direction == TrendDirection.DOWNTREND) ? TrendDirection.UPTREND : TrendDirection.DOWNTREND;
    let slice = 0;

    if (wallDiff < 0) {
      slice = 2
    }
    else if (secondWallDiff < 0) {
      slice = 1
    }

    if (secondWallDiff > 0 && wallDiff < 0) {
      slice = 1;
    }


    if (wallDiff < 0 && secondWallDiff < 0 || wallDiff == 0 || secondWallDiff == 0) {
      slice = 1;
    }
    //

    if (start == 2) {
      slice = 1;
    }

    if (data[start - slice] != undefined) {
      this.zigZagSeriData.push(data[start - slice]);
      let newData = data.slice(start - slice);

      this.prepareData(newdirection, newData);

    }

  }

  public compare(a, b, direction) {
    return direction * (a - b) > 0
  }

  public getSupportedInputTypes(num: number, init: WaveDirection) {
    const initSecond = (init == WaveDirection.UP) ? PointBaseType.MINIMUM : PointBaseType.MAXIMUM;
    const initBase = (init == WaveDirection.UP) ? PointBaseType.MAXIMUM : PointBaseType.MINIMUM;

    if (num % 2 == 0) {
      return initBase;
    }

    return initSecond
  }

}

export enum TrendDirection {
  UPTREND = 1,
  DOWNTREND = -1
}


export class finalBasepoint {
  data: LineData;
  pointBaseType: PointBaseType;
}


export enum PointBaseType {
  MINIMUM = 0,
  MAXIMUM = 1
}
export enum WaveType {
  NOWAVE = 1,
  INTERMEDIATE = 2,
  PERNAMENT = 3
}

export enum DrawingAction {
  DRAW = 1,
  REMOVE = 2,
  UPDATE = 3,
  UPDATEPREVIOUS = 4,
  NOACTION = 5
}

export class Wave {
  type: WaveType;
  direction: WaveDirection;
  data: LineData[];
  serie?: LineWave
}

export enum WaveDirection {
  NODIRECTION = 1,
  UP = 2,
  DOWN = 3
}


export enum WaveDiff {
  INTERMEDIATE = 5,
  PERMANENT = 10
}

export enum PointValue {
  STANDARD = 1,
  SMALL = 0.25
}
